import DocumentDownloadLink from '@rsa-digital/evo-shared-components/components/DocumentDownloadLink';
import React, { MouseEventHandler } from 'react';
import { trackNewDownloadClick } from 'helpers/eventTracking';

type DocumentDownloadLinkBlockProps = {
  document_download_link: DocumentDownloadLinkBlockData;
};

export type DocumentDownloadLinkBlockData = {
  document_name: string;
  document_url: string;
  file_type: string | null;
  file_size: number | null;
  open_in_new_tab: boolean;
  open_in_new_tab_screen_reader_text: string | null;
  hide_icon: boolean;
  description_text: string | null;
};

const DocumentDownloadLinkBlock: React.FC<DocumentDownloadLinkBlockProps> = ({
  document_download_link,
}) => {
  const dataCy = 'DocumentDownloadLink';
  const documentUrl = document_download_link.document_url;
  const fileType = document_download_link.file_type ?? undefined;

  const trackClick: MouseEventHandler = () => {
    trackNewDownloadClick(
      window.location.pathname,
      document_download_link.file_size,
      document_download_link.document_url.split('/').pop(),
      document_download_link.document_name,
      document_download_link.document_url,
      `${document_download_link.document_name}${
        document_download_link.open_in_new_tab_screen_reader_text
          ? ` (${document_download_link.open_in_new_tab_screen_reader_text})`
          : ''
      }`,
      dataCy
    );
  };

  return (
    <DocumentDownloadLink
      data-cy={dataCy}
      documentName={document_download_link.document_name}
      documentUrl={documentUrl}
      fileType={fileType}
      fileSize={document_download_link.file_size ?? undefined}
      openInNewTab={document_download_link.open_in_new_tab}
      openInNewTabScreenReaderText={
        document_download_link.open_in_new_tab_screen_reader_text ?? undefined
      }
      hideIcon={document_download_link.hide_icon}
      descriptionText={document_download_link.description_text ?? undefined}
      onClick={trackClick}
    />
  );
};

export default React.memo(DocumentDownloadLinkBlock);
